import { useContext, useEffect, useState } from 'react';
import ActionButton from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import { Search } from "../../../filtering";
import { pimsMasterDownloadList, TableColumn, TableSettings } from '../../../tableSettings';
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../AbstractListView";
import JobListViewContext from '../JobListViewContext';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,IndicatorRenderer,
  NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer,
} from '../../../uiControls/SmartTableRenderers';
import { JobNames } from '../../../framework.core/JobNames';
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../ListViewShortcutMenu';
import { PimsBookingListItem } from '../../../fms.data/models/PimsBookingListItem';
import * as XCol from '../../../framework.core/XExportColumn';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import PrimaryButton from '../../../ui/PrimaryButton';
import ApplicationContext from '../../../ApplicationContext';
import { useHistory } from 'react-router';
import { NavigationType, openNewPage } from '../../../util/navigationHelpers';

function formatData(data: Array<PimsBookingListItem>) {
  return data;
}

function useSelectedDownloadItem() {
  const jobListContext = useContext(JobListViewContext);

  const selectedElement = jobListContext.selectedElement as PimsBookingListItem | null;

  function view() {
    jobListContext.showPopupRow();
  }

  return { selectedElement, view };
}

function DownloadListCommands({ context }: {
  context: JobNames.OIMMyPims | JobNames.OIMPims | JobNames.OEMMyPims | JobNames.OEMPims |
  JobNames.AIMMyPims | JobNames.AIMPims | JobNames.AEMMyPims | JobNames.AEMPims
}) {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  
  const { selectedElement } = useSelectedDownloadItem();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [view, showView] = useState(false);
  const history = useHistory();
  
  let title = 'Download MBL';
  let buttonCatpion = 'Download to OI';

  switch (context) {
    case JobNames.OIMPims:
    case JobNames.OEMPims:
      title = 'Download MBL';
      break;
    case JobNames.AIMPims:
    case JobNames.AEMPims:
      title = 'Download MAWB';
      break;
  }

  switch (context) {
    case JobNames.OIMPims:
      buttonCatpion = 'Download to OI';
      break;
    case JobNames.OEMPims:
      buttonCatpion = 'Download to OE';
      break;
    case JobNames.AIMPims:
      buttonCatpion = 'Download to AI';
      break;
    case JobNames.AEMPims:
      buttonCatpion = 'Download to AE';
      break;
  }

  async function block(isBlock: boolean) {
    const doBlock = await showGlobalYesNoDialog(<p style={{ fontWeight: 'bold', fontSize: '13px' }}>Are you sure you want to {(isBlock ? "Block" : "Cancel block")}?</p>,false, 0, true)

    if (doBlock) {
      const id = selectedElement?.id;

      await appContext.api.block(context, id, isBlock);

      jobListContext.reloadData();
    }
  }

  function dismissView() {
    showView(false);
    jobListContext.dismissPopupRow();
  }

  async function viewDownloadView() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/oceanImport/download/${context}/${id}`;

    openNewPage(history, viewUrl, NavigationType.newPage);
  }


  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => showView(true)}
        >
          View
        </PrimaryButton>&nbsp;

        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => block(true)}
        >
          Block
        </PrimaryButton>&nbsp;

        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => block(false)}
        >
          Cancel Block
        </PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => viewDownloadView()}
        >
          {buttonCatpion}
        </PrimaryButton>&nbsp;
        <ActionButton
          type="primary"
          variant="plain"
          items={[
            { label: `${title} (All) List` },
            { label: `${title} (Downloaded) List` },
            { label: `${title} (Not Downloaded) List` },
          ]}
        >
          More Menu
        </ActionButton>
      </div>
      <IfmsModal isBlueHeader onCancel={dismissView} draggable isOpen={view || !!jobListContext.viewPopupRow} title="View Voyage" width="760px">
        {/* <ViewVoyage onPopupClose={dismissView} selectedElementId={selectedElement?.id ?? ''} /> */}
      </IfmsModal>
    </div>
  );
}

function DownloadListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function MasterDownloadListViewExtras() {
  useFunctionKeys({ onFunction: onFunctionKey });

  const jobListContext = useContext(JobListViewContext);

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
    if (!unprocessedFkey) {
      return;
    }

    doProcessFkey();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F11', 'F8'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.OiPims}
      jobId={(jobListContext.selectedElement as PimsBookingListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 * Concrete implementation for Download List screen
 *
 * @class MasterDownloadListView
 * @extends {AbstractListView}
 */
class MasterDownloadListView extends AbstractListView {
  private jobName: JobNames.OIMMyPims | JobNames.OIMPims | JobNames.OEMMyPims | JobNames.OEMPims |
    JobNames.AIMMyPims | JobNames.AIMPims | JobNames.AEMMyPims | JobNames.AEMPims;

  constructor(jobName: JobNames.OIMMyPims | JobNames.OIMPims | JobNames.OEMMyPims | JobNames.OEMPims |
    JobNames.AIMMyPims | JobNames.AIMPims | JobNames.AEMMyPims | JobNames.AEMPims) {
    super();
    this.jobName = jobName;
  }

  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(this.jobName,
      'PimsBookingListItem',
      PimsBookingListItem.calculateSearchParameters(search, PimsBookingListItem.MapSearchFields),
      1,
      search.pageSize);

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return { data: [], totalCount: 0 };
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount };
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getRowRenderers(): ListRowRenderer[] {
    return PimsBookingListItem.getExportCollection(this.jobName).map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") colRenderer.Cell = IndicatorRenderer;
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'id')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} useComma={false} decimals={0} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});    
    colRenderer.push({ accessor: 'id', changedValue: (value: any) => { return value['id'] } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'id',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings = pimsMasterDownloadList;
    const cols = PimsBookingListItem.getExportCollection(this.jobName);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type };
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <DownloadListCommands context={this.jobName} />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <DownloadListToolbar />
    );
  }

  renderExtras() {
    return <MasterDownloadListViewExtras />
  }

  getViewUrlFor() {
    return '';
  }

  getListViewTitle() {
    switch (this.jobName) {
      case JobNames.OIMPims:
      case JobNames.OEMPims:
        return 'Download MBL List';
      case JobNames.AIMPims:
      case JobNames.AEMPims:
        return 'Download MAWB List';
      case JobNames.OIMMyPims:
      case JobNames.OEMMyPims:
        return 'Download MY MBL List';
      case JobNames.AIMMyPims:
      case JobNames.AEMMyPims:
        return 'Download MY MAWB List';
    }
  };
};

export default MasterDownloadListView;